import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

/* Component Pages */
import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { InvestorComponent } from './pages/investor/investor.component';
import { AnnualReportComponent } from './pages/investor/annual-report/annual-report.component';
import { AboutComponent } from './pages/about/about.component';
import { CompanyProfileComponent } from './pages/about/company-profile/company-profile.component';
import { VisionComponent } from './pages/about/vision/vision.component';
import { AddressOfficeComponent } from './pages/about/address-office/address-office.component';
import { CompanyAccessComponent } from './pages/about/company-access/company-access.component';
import { ArticleComponent } from './pages/article/article.component';
import { ArticleDetailComponent } from './pages/article/article-detail/article-detail.component';
import { OrganiStructureComponent } from './pages/about/organi-structure/organi-structure.component';
import { GalleryPageComponent } from './pages/gallery-page/gallery-page.component';
import { SustainabilityComponent } from './pages/sustainability/sustainability.component';
import { SusMotionComponent } from './pages/sustainability/sus-motion/sus-motion.component';
import { SusPeopleComponent } from './pages/sustainability/sus-people/sus-people.component';
import { SusPlanetComponent } from './pages/sustainability/sus-planet/sus-planet.component';
import { SusProductComponent } from './pages/sustainability/sus-product/sus-product.component';
import { SusProfitComponent } from './pages/sustainability/sus-profit/sus-profit.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PalmComponent } from './pages/product/palm/palm.component';
import { SriwijayaComponent } from './pages/product/sriwijaya/sriwijaya.component';
import { PrimaComponent } from './pages/product/prima/prima.component';
import { ProductComponent } from './pages/product/product.component';
import { JobsComponent } from './pages/career/jobs/jobs.component';
import { CareerComponent } from './pages/career/career.component';
import { FormCareerComponent } from './pages/career/form-career/form-career.component';
import { FinancialInformationComponent } from './pages/investor/financial-information/financial-information.component';
import { CorporateComponent } from './pages/corporate/corporate.component';
import { ComplianceComponent } from './pages/corporate/compliance/compliance.component';
import { CommitteeComponent } from './pages/corporate/committee/committee.component';
import { InvShareholdersComponent } from './pages/investor/inv-shareholders/inv-shareholders.component';
import { CompanyNewslettersComponent } from './pages/investor/company-newsletters/company-newsletters.component';
import { DisclosuresComponent } from './pages/investor/disclosures/disclosures.component';
import { ShareInformationComponent } from './pages/investor/share-information/share-information.component';
import { SubsidiariesComponent } from './pages/about/subsidiaries/subsidiaries.component';
import { SearchComponent } from './pages/search/search.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { OtherProductComponent } from './pages/product/other-product/other-product.component';

/* Setting Routing */

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 100],
};

/* Routing */

const appRoutes: Routes = [
    {  path: '',  redirectTo: 'home', pathMatch: 'full' },
    {  path: 'home', component: HomeComponent },
    {  path: 'about-us', 
        component: AboutComponent,
        children: [
            { path: '', redirectTo: 'company-profile', pathMatch: 'full'},
            { path: 'company-profile', component:  CompanyProfileComponent },
            { path: 'vision-mission-values',  component:  VisionComponent },
            { path: 'address-of-offices', component: AddressOfficeComponent },
            { path: 'company-access',  component: CompanyAccessComponent },
            { path: 'organization-structure', component:  OrganiStructureComponent },
            { path: 'group-structure-subsidiaries', component:  SubsidiariesComponent }
        ]
    },
    {  path: 'investor', 
        component: InvestorComponent,
        children: [
            { path: '', redirectTo: 'financial-information', pathMatch: 'full'},
            { path: 'annual-reports', component: AnnualReportComponent },
            { path: 'financial-information', component: FinancialInformationComponent },
            { path: 'general-meeting-of-shareholders', component: InvShareholdersComponent},
            { path: 'disclosure', component:  DisclosuresComponent },
            { path: 'share-information', component: ShareInformationComponent },
            { path: 'company-newsletter', component: CompanyNewslettersComponent },
            { path: 'company-newsletters', component: CompanyNewslettersComponent }
        ]
    },
    { path: 'news-and-events', component: ArticleComponent },
    { path: 'news-and-events/:slug/:title', component: ArticleDetailComponent },
    { path: 'sustainability', 
        component: SustainabilityComponent,
        children: [
            { path: '', redirectTo: 'sustainability-in-motion', pathMatch: 'full'},
            { path: 'sustainability-in-motion', component: SusMotionComponent },
            { path: 'people', component:  SusPeopleComponent },
            { path: 'planet', component:  SusPlanetComponent },
            { path: 'product', component:  SusProductComponent },
            { path: 'profit', component: SusProfitComponent }
        ]
    },
    {  path: 'our-products', 
        component: ProductComponent ,
        children: [
            { path: '', redirectTo: 'palm-product', pathMatch: 'full'},
            { path: 'palm-product', component: PalmComponent },
            { path: 'dxp-sriwijaya', component: SriwijayaComponent },
            { path: 'prima-starch', component: PrimaComponent },
            { path: 'other/:slug', component:  OtherProductComponent } 
        ]
    },
    { path: 'gallery', component: GalleryPageComponent },
    { path: 'contact-us', component: ContactUsComponent },
    {  path: 'career', 
        component: CareerComponent,
        children: [
            { path: '',  component: JobsComponent, pathMatch: 'full'},
            { path: 'form-job', component: FormCareerComponent } 
        ]
    },
    {  path: 'corporate-governance', 
        component: CorporateComponent,
        children: [
            { path: '', redirectTo: 'compliance', pathMatch: 'full'},
            { path: 'compliance', component: ComplianceComponent},
            { path: 'committee', component: CommitteeComponent }
        ]
    },
    { path: 'search', component: SearchComponent },
    { path: 'privacy-policy', component: PrivacyComponent },
    { path: 'disclaimer', component: PrivacyComponent },
    { path: 'server-error', component: PageNotFoundComponent, data: { status: true } },
    { path: 'not-found', component: PageNotFoundComponent, data: { status: false } },
    { path: '**', redirectTo: '/not-found' }
];
  
@NgModule({
  imports: [
    // RouterModule.forRoot(appRoutes, {useHash: true})
    RouterModule.forRoot(appRoutes, routerOptions)
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {

}